import { render } from "./WhatWeDoItemNew.vue?vue&type=template&id=78aa8c8b&scoped=true"
import script from "./WhatWeDoItemNew.vue?vue&type=script&lang=js"
export * from "./WhatWeDoItemNew.vue?vue&type=script&lang=js"

import "./WhatWeDoItemNew.vue?vue&type=style&index=0&id=78aa8c8b&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78aa8c8b"]])

export default __exports__